import { Entry } from '../Entry'

export function Entry20260805() {
  return (
    <Entry title="2026 Aug 5 - v3.11.18">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/27043/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
